import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/features/auth/hooks/useAuth";
import { RBAC_STALE_TIME, rbacKeys } from "@/features/rbac/hooks/rbacKeys";
import { resolveSubject } from "@/features/rbac/services/subjectResolver";
import type { RbacSubject } from "@/features/rbac/services/subjectResolver";

/**
 * Perfil de la persona autenticada.
 *
 * Es la ÚNICA carga de perfil de la aplicación. Antes convivían tres caminos
 * independientes (un contexto con `useEffect`, una query de React Query y otro
 * `useEffect` dentro del Layout), que se desincronizaban entre sí y disparaban
 * la misma lectura de Firestore varias veces por render inicial.
 */
export function useCurrentProfile() {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid ?? null;

  return useQuery<RbacSubject | null>({
    queryKey: rbacKeys.profile(uid),
    queryFn: () => (uid ? resolveSubject(uid) : Promise.resolve(null)),
    enabled: uid !== null,
    staleTime: RBAC_STALE_TIME,
  });
}
